import { useEffect, useRef, useState } from "react";

const PdfOrImageUploader = ({
  onChange,
  maxFiles = 5,
  existingFiles = [],
  acceptType = "application/pdf,image/*,.zip,application/zip",
  placeholder = "Upload PDF or Images",
  replaceOnSelect = false,
}) => {
  const [files, setFiles] = useState([]);
  const [removedIds, setRemovedIds] = useState([]);
  const removedIdsRef = useRef([]);

  const detectFileType = (fileName) => {
    if (typeof fileName !== "string") return "image";
    const lower = fileName.toLowerCase();
    if (lower.endsWith(".pdf")) return "pdf";
    if (lower.endsWith(".zip")) return "zip";
    return "image";
  };

  const normalizeDisplayType = (item) => {
    const rawType = (item?.type || "").toLowerCase();
    if (rawType.includes("zip")) return "zip";
    if (rawType.includes("pdf")) return "pdf";
    if (rawType.startsWith("image/")) return "image";
    const nameOrUrl = item?.name || item?.url || item?.preview || "";
    return detectFileType(nameOrUrl);
  };

  useEffect(() => {
    const formatted = (existingFiles || []).map((file) => {
      const rawFile = file.file;
      const hasPreview = typeof file.preview === "string" && file.preview;
      const hasUrl = typeof file.url === "string" && file.url;
      const hasFileUrl = typeof rawFile === "string" && rawFile;
      const url =
        hasPreview
          ? file.preview
          : hasUrl
            ? file.url
            : hasFileUrl
              ? rawFile
              : rawFile instanceof File || rawFile instanceof Blob
                ? URL.createObjectURL(rawFile)
                : "";
      return {
        id: file.id,
        // url: file.file,
        url,
        file: rawFile,
        name: file.name || `Document-${file.id}`,
        // type: file.type || "pdf", // you can pass type from backend
        type: file.type || detectFileType(file.name),
        isExisting: file.isExisting ?? true,
      };
    });

    setFiles(formatted);
  }, [existingFiles]);

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files);
    const baseFiles = replaceOnSelect ? [] : files;
    const remaining = maxFiles - baseFiles.length;

    const newFiles = selected.slice(0, remaining).map((file) => ({
      file,
      // url: URL.createObjectURL(file),
      // url: file.type.includes("image")
      //   ? URL.createObjectURL(file)
      //   : file.type === "application/pdf"
      //   ? URL.createObjectURL(file)
      //   : "", // zip has no preview

      url:
        file.type.includes("image") || file.type === "application/pdf"
          ? URL.createObjectURL(file)
          : null, // zip has no preview

      name: file.name,
      // type: file.type.includes("pdf") ? "pdf" : "image",
      type: detectFileType(file.name),
      isExisting: false,
    }));

    const updated = [...baseFiles, ...newFiles];
    setFiles(updated);

    const payloadFiles = updated.map((f) => {
      if (!f.isExisting) return f.file;
      const url = typeof f.url === "string" ? f.url : "";
      if (url.startsWith("blob:")) {
        return {
          name: f.name,
          type: f.type || detectFileType(f.name),
          preview: url,
        };
      }
      return {
        id: f.id,
        url: f.url || "",
        name: f.name,
        type: f.type || detectFileType(f.name),
        isExisting: true,
      };
    });
    onChange && onChange(payloadFiles, removedIdsRef.current);
    e.target.value = "";
  };

  const handleRemove = (index) => {
    setFiles((prev) => {
      const removed = prev[index];

      if (removed.isExisting && removed.id) {
        const nextRemoved = Array.from(
          new Set([...removedIdsRef.current, removed.id])
        );
        removedIdsRef.current = nextRemoved;
        setRemovedIds(nextRemoved);
      } else {
        URL.revokeObjectURL(removed.url);
      }

      const updated = prev.filter((_, i) => i !== index);

      const payloadFiles = updated.map((f) => {
        if (!f.isExisting) return f.file;
        const url = typeof f.url === "string" ? f.url : "";
        if (url.startsWith("blob:")) {
          return {
            name: f.name,
            type: f.type || detectFileType(f.name),
            preview: url,
          };
        }
        return {
          id: f.id,
          url: f.url || "",
          name: f.name,
          type: f.type || detectFileType(f.name),
          isExisting: true,
        };
      });

      onChange && onChange(payloadFiles, removedIdsRef.current);

      return updated;
    });
  };

  return (
    <div className="form-group mb-2">
      {/* <label className="ct_fs_16  mb-2">
        Upload PDF or Image <span className="text-danger">*</span>
      </label> */}

      <div class="ct_upload_product_main ct_upload_product_main_180 ">
        <label>
          <p class="text-center ct_fs_18 ct_text_op_07 mb-0 ct_cursor_pointer">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 9.00025V15.0002C11.0003 15.2551 11.0979 15.5003 11.2728 15.6856C11.4478 15.871 11.687 15.9825 11.9414 15.9974C12.1958 16.0124 12.4464 15.9296 12.6418 15.766C12.8373 15.6024 12.9629 15.3703 12.993 15.1172L13 15.0002V9.00025H19C19.5046 9.00009 19.9906 9.19066 20.3605 9.53375C20.7305 9.87684 20.9572 10.3471 20.995 10.8502L21 11.0002V20.0002C21.0002 20.5048 20.8096 20.9908 20.4665 21.3608C20.1234 21.7308 19.6532 21.9574 19.15 21.9953L19 22.0002H5C4.49542 22.0004 4.00943 21.8098 3.63945 21.4668C3.26947 21.1237 3.04284 20.6534 3.005 20.1502L3 20.0002V11.0002C2.99984 10.4957 3.19041 10.0097 3.5335 9.6397C3.87659 9.26972 4.34684 9.04309 4.85 9.00525L5 9.00025H11ZM12.884 2.46925L16.243 5.82725C16.4306 6.01489 16.5361 6.26938 16.5361 6.53475C16.5361 6.80011 16.4306 7.05461 16.243 7.24225C16.0554 7.42989 15.8009 7.53531 15.5355 7.53531C15.2701 7.53531 15.0156 7.42989 14.828 7.24225L13 5.41325V9.00025H11V5.41325L9.172 7.24225C9.07909 7.33516 8.96879 7.40886 8.8474 7.45914C8.726 7.50942 8.5959 7.53531 8.4645 7.53531C8.33311 7.53531 8.203 7.50942 8.0816 7.45914C7.96021 7.40886 7.84991 7.33516 7.757 7.24225C7.66409 7.14934 7.59039 7.03904 7.54011 6.91764C7.48982 6.79625 7.46394 6.66614 7.46394 6.53475C7.46394 6.40335 7.48982 6.27325 7.54011 6.15185C7.59039 6.03046 7.66409 5.92016 7.757 5.82725L11.117 2.46925C11.3514 2.23506 11.6692 2.10352 12.0005 2.10352C12.3318 2.10352 12.6496 2.23506 12.884 2.46925Z"
                fill="#023047"
              />
            </svg>
            {placeholder}
          </p>
          <input
            type="file"
            accept={acceptType}
            multiple
            className="d-none"
            onChange={handleFileChange}
            disabled={files.length >= maxFiles && !replaceOnSelect}
          />
        </label>
      </div>

      <div className="ct_multiple_img_div ct_custom_scroll d-flex gap-3 mt-3">
        {files.map((item, index) => (
          <div
            key={index}
            className={`position-relative ct_iframe_hover ${item.type === "zip" ? "ct_file_chip" : ""}`}
            style={item.type === "zip" ? undefined : { width: "120px", height: "120px" }}
          >
            {/* Preview logic */}
            {normalizeDisplayType(item) === "image" && (
              <img
                src={item.url}
                alt="Preview"
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "6px",
                }}
              />
            )}

            {normalizeDisplayType(item) === "pdf" && (
              <iframe
                src={item.url}
                loading="lazy"
                style={{ width: "120px", height: "120px", objectFit: "cover" }}
              ></iframe>
            )}

            {normalizeDisplayType(item) === "zip" && (
              <>
                <div className="ct_file_icon">
                  <i className="fa-regular fa-file-zipper"></i>
                </div>
                <div className="ct_file_name">{item.name}</div>
              </>
            )}

            {/* Eye icon for full view */}
            <a href={item.url} target="_blank" className="ct_pdf_full_view">
              <i className="fa-solid fa-eye ct_cursor_pointer text-white"></i>
            </a>

            {/* Remove icon */}
            <i
              className="fa-solid fa-xmark ct_cursor_pointer position-absolute  p-1"
              onClick={() => handleRemove(index)}
            ></i>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PdfOrImageUploader;
